import { EAdminRoutes } from '@/services/router/enums.ts';
import { TAdminRoles } from '@/types.ts';

export const ROUTES_TO_ROLES_RELATION_MAP = new Map<EAdminRoutes, TAdminRoles[]>([
    [EAdminRoutes.Customers, ['SUPER_ADMIN', 'ADMIN']],
    [EAdminRoutes.Patients, ['SUPER_ADMIN', 'ADMIN']],
    [EAdminRoutes.Dashboard, ['SUPER_ADMIN', 'ADMIN']],
    [EAdminRoutes.Practices, ['SUPER_ADMIN', 'ADMIN']],
    [EAdminRoutes.Admins, ['SUPER_ADMIN']],
]);

export const ADMIN_ROLES: TAdminRoles[] = ['SUPER_ADMIN', 'ADMIN'];
